import React from "react";

const Quote = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M5.33333 14.6668H1.33333C0.596954 14.6668 0 14.0699 0 13.3335V8.73879C0 8.25547 0.131355 7.78124 0.380019 7.3668L3.6116 1.98084C3.85256 1.57923 4.28657 1.3335 4.75492 1.3335H5.58798C6.08356 1.3335 6.40589 1.85504 6.18426 2.29831L3.81574 7.03535C3.5941 7.47862 3.91643 8.00016 4.41202 8.00016H5.33333C6.06971 8.00016 6.66667 8.59712 6.66667 9.33349V13.3335C6.66667 14.0699 6.06971 14.6668 5.33333 14.6668Z"
        fill="white"
        fillOpacity="0.12"
      />
      <path
        d="M14.6663 14.6668H10.6663C9.92996 14.6668 9.33301 14.0699 9.33301 13.3335V8.73879C9.33301 8.25547 9.46436 7.78124 9.71303 7.3668L12.9446 1.98084C13.1856 1.57923 13.6196 1.3335 14.0879 1.3335H14.921C15.4166 1.3335 15.7389 1.85504 15.5173 2.29831L13.1487 7.03535C12.9271 7.47862 13.2494 8.00016 13.745 8.00016H14.6663C15.4027 8.00016 15.9997 8.59712 15.9997 9.33349V13.3335C15.9997 14.0699 15.4027 14.6668 14.6663 14.6668Z"
        fill="white"
        fillOpacity="0.12"
      />
    </svg>
  );
};

export default Quote;
